export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 3_06.9a04580e.jpg";